export const formatNumber = (number: any) => {
  if (!Number(number)) return number;
  return new Intl.NumberFormat().format(number);
};
